export default {
  data: function() {
    return {
      typeAheadPointer: -1
    }
  },
  watch: {
    filtered: function() {
      this.typeAheadPointer = 0;
    }
  },
  methods: {
    typeAheadUp: function() {
      if (this.typeAheadPointer > 0) {
        this.typeAheadPointer--;
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll();
        }
      }
    },
    typeAheadDown: function() {
      if (this.typeAheadPointer < this.filtered.length - 1) {
        this.typeAheadPointer++;
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll();
        }
      }
    },
    typeAheadSelect: function(cohort) {
      var selectedOption = this.filtered[this.typeAheadPointer]
      if (selectedOption) {
        var isAboveLevel = this.checkAboveLevel(selectedOption.level, cohort)
        this.select({
          option: selectedOption,
          isAboveLevel: isAboveLevel,
        })
      }
    },
    checkAboveLevel: function(level, cohort) {
      if (cohort === 'advanced') { return true }
      if (cohort === 'basic' && level !== 'advanced') { return true }
      return false
    },
  },
}
